export const environment = {
    production: false,
    agmKey: 'AIzaSyDsQyM7K5kR6i7yI-2_U_nONiLEqXS9mmM',
    apiUrl: 'https://api.dev.themediaconnector.com',
    assetUrl: 'https://api.dev.themediaconnector.com',
    stripePublicKey:
        'pk_live_51Jo4yYFF6foCrRl2kGd4ll35WByRfcgPGXZXkS1wdsF8wWPZ5S0KjAp5HO0ggrYxnFBzr253EybFAv4yWmni0fCu00GIU9JFz4'
};
